// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"a40e4152","71":"f4877f7e","122":"991ff6d9","147":"9df5f2f0","160":"2f7f0f47","191":"359c5d1b","237":"dedff675","264":"6fb17e68","405":"c48efeb8","453":"6d94061d","552":"2fa44a49","823":"9599f845","867":"8ea79af5","877":"099a0f82","884":"0c267e0a","928":"59f61c23"}[chunkId] + ".chunk.js";
};